import { useContext } from 'react';
import { AppContext } from '../../contexts/context';

// Material UI
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { useTheme } from '@mui/styles';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';

import { saveDemoMode } from '../../models/demoMode';

// Shared wording, also used by the DemoModeDialog opened from the app bar icon.
export const DEMO_MODE_INFO_TEXT = 'The app is currently in demo mode and can be tested without an NFC device. To read data from an NFC device, you must exit demo mode.';

// Leaves demo mode (clearing the demo data) so a real NFC device can be read again.
export const useExitDemoMode = () => {
  const [ , dispatch ] = useContext(AppContext);

  return () => {
    saveDemoMode(false);
    dispatch({type: 'app/settings/demoMode/toggle', value: false});
    dispatch({type: 'ndef/control/setForNewRead'});
    dispatch({type: 'data/source/set', value: 'unknown'});
    dispatch({type: 'app/env/resetToNoData'});
    dispatch({
      type: 'app/ui/snackbar/show',
      message: 'Demo mode disabled.',
      severity: 'success'
    });
  };
};

// Shown on the home screen while demo mode is active. On the data (form) screen
// the app bar icon takes over and opens the DemoModeDialog instead.
export const DemoModeCard = () => {
  const theme = useTheme();
  const handleExitDemoMode = useExitDemoMode();

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms'}}>
      <Card sx={{
          border: '1px solid',
          borderColor: theme.palette.primary.main,
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          paddingX: 2,
          boxShadow: "none",
          alignItems: "left",
          justifyContent: "left"
        }}>
        <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
                <VideogameAssetIcon color={"primary"} sx={{fontSize:50, color: theme.palette.primary.main}}/>
              </Avatar>
            }
            title="Information"
            subheader={"Demo mode is enabled"}
            titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
        />
        <CardContent sx={{mt:0, pt:0, pb:0}}>
          <Typography variant="body2" color="text.secondary">
            {DEMO_MODE_INFO_TEXT}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            onClick={handleExitDemoMode}
          >
            Exit Demo Mode
          </Button>
        </CardActions>
      </Card>
    </Zoom>
  )
}

export default DemoModeCard;
